import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';

/**
 * PDP price sync (enervit)
 *
 * PROČ: Hlavní cena na PDP (`blocks/buy-buttons.liquid` → `.product-form-price` →
 * `{% render 'price' %}`) NENÍ obalená v `<product-price>` komponentě, takže ji Horizon
 * mechanismus změny varianty neaktualizoval — po přepnutí varianty zůstala stará cena
 * (do košíku se přidala správná, ale zobrazená nad CTA byla stará). Viz regression-log
 * 2026-07-26 „PDP cena nad CTA se nemění".
 *
 * JAK: `variant-picker` na normální PDP morphuje jen sebe a dispatchne `VariantUpdateEvent`
 * na nejbližší sekci; `event.detail.data.html` je NAfetchovaná CELÁ stránka produktu s cenou
 * nové varianty. Tady na ten event navážeme a přemorphujeme celý `.product-form-price`
 * (cena + řádek „bez DPH", který je mimo `[ref=priceContainer]`, takže `<product-price>`
 * by ho stejně neaktualizoval). Izolované: žádný zásah do sdíleného price.liquid /
 * product-price.js / product-card.js.
 */

function bindSection(section) {
  if (section.dataset.pdpPriceSyncBound === 'true') return;
  if (!section.querySelector('.product-form-price')) return;
  section.dataset.pdpPriceSyncBound = 'true';

  section.addEventListener(ThemeEvents.variantUpdate, (event) => {
    const html = event?.detail?.data?.html;
    if (!html) return;

    const currentPrice = section.querySelector('.product-form-price');
    const newPrice = html.querySelector('.product-form-price');
    if (!currentPrice || !newPrice) return;

    morph(currentPrice, newPrice);
  });
}

function init() {
  for (const section of document.querySelectorAll('.shopify-section')) {
    bindSection(section);
  }
}

init();
// Theme editor / dynamické načtení sekce → znovu navázat (guard přes dataset drží idempotenci).
document.addEventListener('shopify:section:load', init);
